import axios from 'axios';

export const testProfileAuth = async () => {
  try {
    console.log('🧪 Testing profile auth endpoint...');
    const response = await axios.get('http://localhost:3001/api/profile/test-auth');
    console.log('🧪 Test auth response:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('🧪 Test auth error:', error.response?.status, error.response?.data || error.message);
    return null;
  }
};

// Add this to window for testing in browser console
if (typeof window !== 'undefined') {
  (window as any).testProfileAuth = testProfileAuth;
}